
export default function formatQueryParams(params: any) {
    let result = {}
    Object.keys(params).map((item) => {
        if (typeof params[item] == 'object') {
            if (params[item].indexOf('ALL') < 0 && params[item].indexOf(0) < 0) {
                result[item] = params[item].map((item) => {
                    return "'"+item+"'";
                }).toString()
            } else {
                // when 'ALL' filter is selected, neglect other selections
                result[item] = params[item].indexOf('ALL') >= 0 ? 'ALL': '0'
            }
        } else {
            result[item] = params[item]
        }
    })
    return result
}
